import { DeleteHistoryModal} from "./DeleteHistoryModal";

export default DeleteHistoryModal;
